export const getGeoOption = (geoData: any) => {
    if (!geoData || !geoData.states || geoData.states.length === 0) return {};

    const topStates = geoData.states.slice(0, 15);

    return {
        title: {
            text: `${geoData.country || 'US'} 各州订单排行 (Top 15)`,
            textStyle: { fontSize: 14, fontWeight: 600, color: '#1f2937' },
            left: 'center'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e5e7eb',
            textStyle: { color: '#374151' },
            formatter: (params: any) => {
                const idx = params[0]?.dataIndex;
                if (idx === undefined) return '';
                const stateData = topStates[idx];
                return `<div style="font-weight:600;margin-bottom:4px">${stateData.ship_state}</div>
                    订单数: <b>${stateData.order_count?.toLocaleString() || 0}</b><br/>
                    销售额: <b>$${parseFloat(stateData.sales || 0).toLocaleString()}</b><br/>
                    销量: <b>${(stateData.units || 0).toLocaleString()}</b>`;
            }
        },
        legend: {
            data: ['订单数', '销售额'],
            bottom: 0,
            textStyle: { color: '#6b7280' }
        },
        grid: { left: '3%', right: '4%', bottom: '12%', top: '15%', containLabel: true },
        xAxis: {
            type: 'category',
            data: topStates.map((s: any) => s.ship_state),
            axisLabel: { rotate: 45, color: '#6b7280', fontSize: 11 },
            axisLine: { lineStyle: { color: '#e5e7eb' } },
            axisTick: { show: false }
        },
        yAxis: [
            {
                type: 'value',
                name: '订单数',
                nameTextStyle: { color: '#6b7280', fontSize: 11 },
                axisLabel: { color: '#6b7280' },
                splitLine: { lineStyle: { color: '#f3f4f6', type: 'dashed' } },
                axisLine: { show: false }
            },
            {
                type: 'value',
                name: '销售额 ($)',
                nameTextStyle: { color: '#6b7280', fontSize: 11 },
                axisLabel: { color: '#6b7280', formatter: (v: number) => v >= 1000 ? (v / 1000).toFixed(0) + 'k' : v },
                splitLine: { show: false },
                axisLine: { show: false }
            }
        ],
        series: [
            {
                name: '订单数',
                type: 'bar',
                data: topStates.map((s: any) => s.order_count),
                barMaxWidth: 25,
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#60a5fa' },
                            { offset: 1, color: '#3b82f6' }
                        ]
                    },
                    borderRadius: [4, 4, 0, 0]
                }
            },
            {
                name: '销售额',
                type: 'line',
                yAxisIndex: 1,
                data: topStates.map((s: any) => parseFloat(s.sales) || 0),
                smooth: true,
                symbol: 'circle',
                symbolSize: 8,
                lineStyle: { width: 3, color: '#10b981' },
                itemStyle: { color: '#10b981', borderWidth: 2, borderColor: '#fff' }
            }
        ]
    };
};
